<template>
  <div class="customer-payment body">
    <el-container>
      <!-- <CustomersAside /> -->
      <el-main>
        <div class="bg-White p-3 mt-2">
          <el-row :gutter="10">
            <el-col :xl="10" :lg="10" :md="6" :sm="12">
              <el-input
                v-model="customerName"
                @keyup.native="filterCustomer"
                placeholder="بحـث باسـم المورد"
              />
            </el-col>
            <el-col :pull="12" :lg="2">
              <el-button
                type="success"
                title="طباعه"
                icon="el-icon-printer"
                @click="sendToPrint()"
              ></el-button>
            </el-col>
          </el-row>
        </div>
        <el-table class="table-mobile" :data="tableData" border>
          <el-table-column
            label="#"
            type="index"
            width="50"
            class-name="display-mobile-none"
          />
          <el-table-column label="الاسم" prop="name" width="220px">
            <template slot-scope="scope">
              <span class="label"> {{ scope.$index + 1 }} # الأسم </span>
              <div>
                {{ scope.row.name }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="الهاتف" prop="phone" width="150px">
            <template slot-scope="scope">
              <span class="label"> الهاتف </span>
              <div>
                {{ scope.row.phone }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="العنوان" prop="address">
            <template slot-scope="scope">
              <span class="label"> العنوان </span>
              <div>
                {{ scope.row.address }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="الحساب" width="150px">
            <template slot-scope="scope">
              <span class="label"> الحساب </span>
              <div>
                {{
                  numberToFixed(
                    Number(scope.row.balance) + Number(scope.row.account)
                  )
                }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="اجراء" width="110px">
            <template slot-scope="scope">
              <el-row type="flex" :gutter="10">
                <el-col :lg="12" :span="12" v-if="accessLinks('update_supplier')">
                  <el-button
                    size="mini"
                    type="warning"
                    title="تعديل"
                    icon="el-icon-edit"
                    @click="editSuppliers(scope.row)"
                  >
                  </el-button>
                </el-col>
                <el-col :lg="12" :span="12"  v-if="accessLinks('delete_supplier')">
                  <el-popconfirm
                    confirm-button-text="موافق"
                    cancel-button-text="إلغاء"
                    icon="el-icon-info"
                    icon-color="red"
                    :title="'هل تريد حذف ' + ' ' + scope.row.name + ' ؟'"
                    @confirm="deleteSuppliers(scope.row.id)"
                  >
                    <div slot="reference">
                      <el-button
                        title="حذف"
                        type="danger"
                        size="mini"
                        icon="el-icon-delete"
                      ></el-button>
                    </div>
                  </el-popconfirm>
                </el-col>
              </el-row>
            </template>
          </el-table-column>
        </el-table>
        <el-dialog
          :fullscreen="false"
          title="تعديل بيانات المورد"
          :visible.sync="editFormVisible"
          v-if="selectedSuppliers"
        >
          <el-form
            :rules="rules"
            ref="NewSuppliers"
            :model="selectedSuppliers"
            label-width="120px"
            label-position="top"
          >
            <el-row :gutter="10">
              <el-col :xl="10" :lg="10" :md="24" :sm="24">
                <el-form-item label="الاسم" prop="name">
                  <el-input
                    class="input3"
                    @focus="$event.target.select()"
                    v-model="selectedSuppliers.name"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :xl="6" :lg="6" :md="12" :sm="12">
                <el-form-item label="رقم الهاتف" prop="phone">
                  <el-input
                    class="input4"
                    id="phone"
                    @focus="$event.target.select()"
                    v-model="selectedSuppliers.phone"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :xl="8" :lg="8" :md="12" :sm="12">
                <el-form-item label="العنوان" prop="address">
                  <el-input
                    class="input5"
                    id="address"
                    @focus="$event.target.select()"
                    v-model="selectedSuppliers.address"
                  ></el-input>
                </el-form-item>
              </el-col>
              <!-- <el-col :xl="4" :lg="4" :md="12" :sm="12">
                <el-form-item label="رصيد العميل" prop="account">
                  <el-input
                    class="input4"
                    id="account"
                    type="number"
                    @focus="$event.target.select()"
                    v-model="selectedSuppliers.account"
                    controls-position="right"
                    @keyup.enter.native="focusNext"
                  ></el-input>
                </el-form-item>
              </el-col> -->
              <!-- <el-col :xl="4" :lg="4" :md="12" :sm="12" v-if="form.type == 2">
                <el-form-item label="رصيد المورد" prop="supplier_account">
                  <el-input
                    :class="form.type == 2 ? 'input5' : ''"
                    id="supplier_account"
                    @focus="$event.target.select()"
                    v-model="form.supplier_account"
                    @keyup.enter.native="focusNext"
                  ></el-input>
                </el-form-item>
              </el-col> -->
            </el-row>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button type="warning" @click="update">حفظ التعديلات</el-button>
            <el-button class="mr-3" @click="editFormVisible = false"
              >إلغاء</el-button
            >
          </span>
        </el-dialog>
      </el-main>
    </el-container>
  </div>
</template>

<script>
// import CustomersAside from "@/components/CustomersAside.vue";
import axiosApi from "@/plugins/axios.js";
// import { ipcRenderer } from "electron";
export default {
  data() {
    return {
      tableData: [],
      editFormVisible: false,
      selectedSuppliers: {},
      rules: {
        type: [
          { required: true, message: "حدد نوع حساب العميل", trigger: "blur" },
        ],
        name: [{ required: true, message: "حدد اسم العميل", trigger: "blur" }],
        account: [
          { required: true, message: "حدد الرصيد الافتتاحي", trigger: "blur" },
        ],
        price_type: [
          { required: true, message: "حدد سياسة التسعير ", trigger: "blur" },
        ],
        address: [{ required: true, message: "حدد العنوان ", trigger: "blur" }],
        phone: [
          { required: true, message: "حدد رقم الهاتف", trigger: "blur" },
          { min: 11, max: 11, message: "حدد رقم هاتف صحيح", trigger: "change" },
        ],
      },
      customerName: "",
    };
  },
  methods: {
    numberToFixed(number) {
      return Math.floor(number * 100) / 100;
    },
    getAllSuppliers() {
      const loading = this.$loading({
        lock: true,
        text: "جاري تحميل البيانات",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      axiosApi
        .get("suppliers")
        .then((res) => {
          this.tableData = res.data;
          localStorage.setItem("suppliersReportAll", JSON.stringify(res.data));
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          loading.close();
        });
    },
    editSuppliers(row) {
      this.selectedSuppliers = {};
      this.selectedSuppliers = row;
      this.editFormVisible = true;
    },
    update() {
      const loading = this.$loading({
        lock: true,
        text: "جاري تحميل البيانات",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      axiosApi
        .put(`suppliers/${this.selectedSuppliers.id}`, this.selectedSuppliers)
        .then((res) => {
          this.editFormVisible = false;
          this.selectedSuppliers = {};
          this.tableData = res.data;
          this.$notify({
            title: "تمت العملية بنجاح",
            message: "تم حفظ بيانات العميل بنجاح",
            type: "success",
            duration: 1500,
          });
        })
        .catch(() => {
          this.$notify.error({
            title: "حدث خطأ",
            message: "عفوا تأكد من بيانات المطلوبة",
            duration: 1500,
          });
        })
        .finally(() => {
          loading.close();
        });
    },
    deleteSuppliers(id) {
      const loading = this.$loading({
        lock: true,
        text: "جاري تحميل البيانات",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      axiosApi
        .delete(`suppliers/${id}`)
        .then((res) => {
          this.$notify({
            title: "تمت العملية بنجاح",
            message: "تم حذف بيانات العميل بنجاح",
            type: "success",
            duration: 1500,
          });
          this.getAllSuppliers();
          console.log(res);
        })
        .catch(() => {
          this.$notify.error({
            title: "حدث خطأ",
            message: "عفوا تأكد من بيانات المطلوبة",
            duration: 1500,
          });
        })
        .finally(() => {
          loading.close();
        });
    },
    filterCustomer() {
      let Data = [];
      let ReportAll = JSON.parse(localStorage.getItem("suppliersReportAll"));
      if (this.customerName !== "") {
        for (let i = 0; i < ReportAll.length; i++) {
          if (ReportAll[i].name.match(this.customerName)) {
            Data.push(ReportAll[i]);
          }
        }
      } else {
        Data = ReportAll;
      }
      this.tableData = Data;
    },
    sendToPrint() {
      // window.ipcRenderer = ipcRenderer;
      // let data = {
      //   data: this.tableData,
      //   type: "CustomersReportAll",
      //   customer: { customerName: this.customerName, isCustomer: false },
      //   img:
      //     "https://pos.staging.fatura-app.com" +
      //     JSON.parse(localStorage.getItem("branch")).logo,
      // };
      // ipcRenderer.send("printing", data);
    },
    accessLinks(link) {
      let permissionNames = JSON.parse(localStorage.getItem("permissionNames"));
      return permissionNames.includes(link);
    },
  },
  mounted() {
    this.getAllSuppliers();
  },
};
</script>

<style scoped>
.el-table {
  width: 100%;
  max-height: 89%;
  overflow-y: scroll;
}
</style>
